/* API Constants */
/* Endpoint urls, query param keys, timeout values, routes etc. */

export const HEADER_PWB_JWT_TOKEN = 'x-pwb-jwt-token';
export const HEADER_TRACKING_ID = 'tracking_id';

// Dispatch events
// todo: add all constants in api duck files here
export const DASHBOARD_SUCCESS = 'vrp-dashboard/DASHBOARD_SUCCESS';
export const DASHBOARD_FAILURE = 'vrp-dashboard/DASHBOARD_FAILURE';

// API endpoints
export const DASHBOARD_API = '/payments/v1/pwb/vrp/dashboard';
export const VRP_DASHBOARD_PATH = '/pwb/v1/payments/vrp/dashboard';
export const VRP_DASHBOARD_DELETE_PATH = '/pwb/v1/payments/vrp/dashboard/delete/consent';
export const VRP_DASHBOARD_GET_VRP_DETAILS = '/pwb/v1/payments/vrp/dashboard/get/consent/details';
